<div class="wrap">
    <header>
        <div class="service">
            <img src="./../../../assets/okito/images/okito-logo.svg" class="icon-size-56">
            <h2>Realtime Partner Tracking</h2>
        </div>
        <div class="date">
            <img src="./../../../assets/okito-comcenter/images/date.svg">
            <small>{{ date | date:'dd-MM-yyyy' }}</small>
            <small>{{ date | date:'h:mm:ss a' }}</small>
        </div>
    </header>
    <div class="main-content tracker-content">
        <!-- MAP HOLDER -->
         <app-rt-map-layout></app-rt-map-layout>
        <!-- MAP CARDS -->
        <app-rt-map-counters></app-rt-map-counters>
    </div>
</div>